import { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestsQueryKey } from "../bond-request.keys";
import { BondRequest } from "./types";

export const useFetchBondRequest = (accountId: SuretyAccountId, id: SuretyQuoteId) => {
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestsQueryKey(id),
		queryFn: async () => await get<BondRequest>(`/v2/surety/accounts/${accountId}/quotes/${id}`),
		retry: false,
	});

	return {
		bondRequest: data,
		bondRequestError: error,
		bondRequestLoading: isLoading,
	};
};
